import styled from '@emotion/styled';

const StyledButton = styled.a``;

const BreadScrumTitle = styled.div`
  color: var(--dk-text-secondary, #888d96);
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px; /* 150% */
  cursor: default;
`;

const BreadcrumbChild = styled.div`
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 24px; /* 150% */
  cursor: default;
`;

const BreadcrumbClickable = styled.div`
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px; /* 150% */
  color: var(--dk-text-secondary, #888d96);
  cursor: pointer;
`;

export { StyledButton, BreadcrumbChild, BreadScrumTitle, BreadcrumbClickable };
